import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { VerificationService,
         SuccessResponse,
         CopyToClipboard,
         getCompanyName,
         closeTabRef,
} from '@sheerid/jslib';

import { ReturnToWSJButtonComponent } from '../ReturnToWSJButtonComponent';

interface StepSuccessProps {
    verificationService: VerificationService;
}

const redirect = (redirectDestination: string) => {
    const win = window.open(redirectDestination, '_parent');
    // @ts-ignore
    win.focus();
};

const StepSuccessComponent = ({ verificationService }: StepSuccessProps) => {
    // Close any open tab for SSO login
    closeTabRef();

    let showRedirect: boolean;
    let redirectDestination: string;

    try {
        showRedirect = verificationService.programTheme.intl.messages.step.success.redirectUrl.length > 0
            && verificationService.programTheme.intl.messages.step.success.redirectButtonText.length > 0;
        redirectDestination = verificationService.programTheme.intl.messages.step.success.redirectUrl;
    } catch (e) {
        showRedirect = false;
    }

    const rewardCode = (verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}';

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-l-horz-center">
                </div>
                <div className="sid-verification_title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.docUpload.verificationTitle" defaultMessage="STUDENT VERIFICATION" />
                </div>
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-two-thirds-width">
                    <FormattedHTMLMessage id="step.success.subtitle" defaultMessage={
                        `Here is your personal coupon code.
                        It is unique to you and can only be used once.`
                    } />
                </div>
            </div>

            <div className="sid-reward-code sid-l-space-top-lg sid-h-jumbo-text sid-l-horz-center">
                {rewardCode}
            </div>

            <div className="sid-l-space-top-md sid-h-bold-text sid-l-horz-center">
                <CopyToClipboard
                    textToCopy={rewardCode}
                >
                    <FormattedHTMLMessage id="step.success.copyCouponCode" defaultMessage="Copy Coupon code" />
                </CopyToClipboard>
            </div>
            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg">
                <FormattedHTMLMessage id="step.success.emailNotification" defaultMessage={`
                    We have emailed you a copy so you can use your code now or later. Look for the email from verify@sheerid.com
                `} />
            </div>

            {
                (showRedirect) ?
                    <div className="sid-submit sid-l-space-top-md">
                        <ReturnToWSJButtonComponent verificationService={verificationService}/>
                    </div> : ''
            }

            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <FormattedHTMLMessage id="step.success.verificationOnly"
                    defaultMessage={`
                        SheerID handles verification only.
                        Now that you've been approved, please direct all questions about the
                        promotion terms and/or code use to {companyName} customer service.
                    `}
                    values={{
                        companyName: getCompanyName(verificationService.programTheme),
                    }}
                />
            </div>
        </div>
    );
};

export { StepSuccessComponent };
